import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { EkubService } from './ekub.service';
import { ActivatedRoute } from '@angular/router';
import { Main } from '@app/core/main.service';
import { environment } from '@env/environment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgxImageCompressService } from 'ngx-image-compress';

@Component({
    selector: 'cp-award-detail',
    templateUrl: './award.detail.component.html',
    styleUrls: ['./award.detail.component.scss']
})
export class AwardDetailComponent {
    award: any = { guarantee_libres: [], guarantee_cartas: [] };
    id: string;
    ekub_date: any;
    filter: string;
    itemsPerPage: number;
    totalItems: number;
    currentPage: number;
    drawDate: any;
    today: any;
    days: any;
    hours: any;
    minutes: any;
    seconds: any;
    ekubMembers: any = [];
    failSafe = false;
    interval: any;
    baseUrl: string = environment.production
        ? environment.ONLINE_BASE_URL :
        environment.LOCAL_BASE_URL;

    //guarantee fields
    guaranteeForm!: FormGroup;
    operation: string = 'add';
    users: any[];
    guarantees: any = [];
    userStats: any;
    winnerStats: any;
    totalGuaranteeAmount: number = 0;
    totalEkubs: number = 0;
    winnerBalance: number = 0;

    file: any;
    files: File[] = [];
    files_temp: any = [];
    localUrl: any;
    localCompressedURl: any;
    sizeOfOriginalImage: number;
    sizeOFCompressedImage: number;
    imgResultBeforeCompress: string;
    imgResultAfterCompress: string;

    uploading = false;
    successUploadCount = 0;
    failedUploadCount = 0;
    error: string;
    userId: number = 1;
    uploadResponse = { status: '', message: '', filePath: '' };

    selectedGuarantee: any = { type: 'libre' };
    selectedGuaranteeImage: string;

    get guarantee() { return this.guaranteeForm.get('guarantee'); }
    get status() { return this.guaranteeForm.get('status'); }
    get remark() { return this.guaranteeForm.get('remark'); }
    get type() { return this.guaranteeForm.get('type'); }
    get guarantee_ref_number() { return this.guaranteeForm.get('guarantee_ref_number'); }
    get guarantee_value() { return this.guaranteeForm.get('guarantee_value'); }
    // additional standalone fields
    get code() { return this.guaranteeForm.get('code'); }
    get winner() { return this.guaranteeForm.get('winner'); }


    constructor(private api: EkubService,
        @Inject(Restangular) public Restangular, private route: ActivatedRoute, private mainService: Main, private formBuilder: FormBuilder, private imageCompress: NgxImageCompressService) {
        this.filter = '';
        this.itemsPerPage = 10;
        this.totalItems = 0;
        this.currentPage = 1;
        this.id = this.route.params['value']['id'];
        this.getAward(this.id);
        // this.getEkubMembers();
    }

    ngOnInit() {
        this.createForm();
        /*  this.getAllEkubs("&status=active");
         if (this.id) {
           this.getAward();
         } */
    }


    private createForm() {

        this.guaranteeForm = this.formBuilder.group({
            guarantee: ['', []],
            status: ['pending', Validators.required], // pending, active, released
            type: ['member', Validators.required],
            guarantee_ref_number: ['', Validators.required],
            winner: [''],
            guarantee_value: [''],
            code: [''],
            remark: [''],
        });

    }


    getAward(awardId: any) {
        this.api.getAward(awardId, "?include=guarantees").subscribe((resp: any) => {
            this.award = resp.data;
            this.award.guarantee_libres = [];
            this.award.guarantee_cartas = [];
            this.ekubMembers = this.award?.ekub?.data?.members?.data;
            this.guarantees = this.award?.guarantees?.data;
            if (this.guarantees && this.guarantees.length > 0) {
                this.guarantees.forEach(a => this.totalGuaranteeAmount += a.amount_guaranteed);
                this.guarantees.forEach(element => {
                    if (element.type == 'member') {
                        element.guarantee = element.guarantor.data.id;
                    }
                    if (element.type == 'libre') {
                        this.award.hasLibre = true;
                        if (element.files.data.length > 0) {
                            var libres = (element.files.data.filter(
                                (file: any) => file.designation.toLowerCase().indexOf('guarantee/libre'.toLowerCase()) !== -1)
                            );
                            this.award.guarantee_libres.push(...libres);
                        }
                    }
                    if (element.type == 'carta') {
                        this.award.hasCarta = true;
                        if (element.files.data.length > 0) {
                            var cartas = (element.files.data.filter(
                                (file: any) => file.designation.toLowerCase().indexOf('guarantee/carta'.toLowerCase()) !== -1)
                            );
                            this.award.guarantee_cartas.push(...cartas);
                        }
                    }
                });
            }
            debugger;
            if (this.award.status == 'scheduled') {
                this.startInterval(awardId);
            } else {
                this.mainService.toast({ title: 'Warning', body: 'This award is not schedule or is already drawed!', type: 'primary' });
            }

            if (resp.data?.winner?.data?.id) {
                this.winner.setValue(resp.data.winner.data.id);
                this.code.setValue(resp.data?.code);
                this.fetchWinnerStats(resp.data.winner.data.id);
            } else {
                this.winner.setValue('');
            }
        });
    }

    /*    getEkubMembers() {
           this.api.getEkubMembersList(this.id, this.currentPage, this.filter).subscribe((resp: any) => {
               debugger;
               this.ekubMembers = resp.data;
               this.totalItems = resp.meta.pagination.total;
               this.itemsPerPage = resp.meta.pagination.per_page;
           }, (err: any) => {
               debugger;
               //this.mainService.addToast('Error', err.statusText);
               this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
           });
       }
    */
    startInterval(awardId) {
        this.checkAward(awardId);
        this.interval = setInterval(() => {
            console.log("setting interval...");
            this.checkAward(awardId);
        }, 5000);
    }

    checkAward(awardId) {
        this.today = new Date();
        console.log("checking award date ...")
        this.api.getAward(awardId, "?include=guarantees").subscribe((res: any) => {
            this.award = res.data;
            this.drawDate = new Date(this.award.draw_date);
            console.log(this.today);
            console.log(this.drawDate);
            this.days = Math.floor((this.drawDate - this.today) / (1000 * 60 * 60 * 24));
            this.hours = Math.floor(Math.abs(this.drawDate - this.today) / (1000 * 60 * 60) % 24);
            this.minutes = Math.abs(this.drawDate.getTime() - this.today.getTime()) / (1000 * 60) % 60;
            console.log("days" + this.days);
            console.log("Minutes" + this.minutes);
            console.log("Hours" + this.hours);
            this.seconds = Math.floor((Math.abs(this.drawDate.getTime() - this.today.getTime()) / (1000) % 60));
            if (this.days < 0) {
                //if (this.days < 1 && this.hours < 1 && this.minutes < 0) {
                this.mainService.toast({ title: 'Info', body: 'This Award has passed!', type: 'info' });
                clearInterval(this.interval);
            }
            else if (this.days < 1 && this.hours < 1 && this.minutes < 5) {
                clearInterval(this.interval); //stop that interval
                this.drawAward(awardId);
            }

        }, (err: any) => {
            console.log(err);
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
        });
    }

    drawAward(awardId: string) {
        debugger;
        this.api.drawAward(awardId).subscribe((res: any) => {
            debugger;
            this.mainService.toast({ title: 'Success', body: "Award Successfully drawed!", type: 'success' });
            //this.getEkubMembers();
            this.getAward(awardId);
            this.failSafe = false;
        }, (err: any) => {
            debugger;
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
            this.failSafe = false;
        });
    }

    activateFailSafe() {
        if (this.award.status == 'scheduled') {
            this.failSafe = true;
            setTimeout(() => { this.drawAward(this.id); }, 5000);

        } else {
            this.mainService.toast({ title: 'Warning', body: 'This award is not scheduled or is already!', type: 'primary' });
        }

    }


    //Guarantee methods

    isOperationAdd(): boolean {
        return (this.operation == "add");
    }

    fetchUser(searchTerm: any) {
        debugger;
        console.log(searchTerm.target.value);
        if (searchTerm.target.value) {
            this.api.fetchUsers(searchTerm.target.value).subscribe((res: any) => {
                debugger;
                //this.isLoading = !this.isLoading;
                this.users = res.data;
                for (let user of this.users) {
                    user.text = user.username + ' - ' + user.email;
                    user.id = user.id;
                }
            }, (err) => {
                debugger;
                err = err;
                //this.isLoading = !this.isLoading;
                this.mainService.toast({ title: 'Error', body: 'Could not fetch users!', type: 'danger' });
            });
        }

    }


    fetchWinnerStats(id: string) {
        debugger;
        this.winnerStats = null;
        this.api.getUserStats(id).subscribe((res: any) => {
            debugger;
            //this.isLoading = !this.isLoading;
            this.winnerStats = res.data;
            this.winnerBalance = this.winnerStats.total_balance;
        }, (err) => {
            debugger;
            err = err;
            //this.isLoading = !this.isLoading;
            this.mainService.toast({ title: 'Error', body: 'Could not fetch winner stats!', type: 'danger' });
        });


    }

    fetchUserStats() {
        debugger;
        this.userStats = null;
        var searchTerm = this.guarantee.value;
        console.log(searchTerm);
        if (searchTerm) {
            this.api.getUserStats(searchTerm).subscribe((res: any) => {
                debugger;
                //this.isLoading = !this.isLoading;
                this.userStats = res.data;
                if (this.userStats.total_balance <= 0) {
                    this.mainService.toast({ title: 'Error', body: 'User doesn\'t have enough balance to be a guarantee. balance = ' + this.userStats.total_balance, type: 'danger' });
                    this.guarantee.setValue(null);
                }
            }, (err) => {
                debugger;
                err = err;
                //this.isLoading = !this.isLoading;
                this.mainService.toast({ title: 'Error', body: 'Could not fetch users!', type: 'danger' });
            });
        }

    }

    checkValidity() {
        if (this.operation != "add") {
            if (this.type.value == "member" && (this.totalGuaranteeAmount < this.winnerBalance)) {
                return true;
            } else {
                return false;
            }
        }

    }



    // File upload


    setSelectedGuarantee(guarantee: any) {
        debugger;
        this.selectedGuarantee = guarantee;
    }

    onSelect(event) {
        console.log(event);
        this.files.push(...event.addedFiles);
        console.log(this.files);
    }

    onRemove(event) {
        console.log(event);
        this.files.splice(this.files.indexOf(event), 1);
        console.log(this.files);

    }

    onFilesAdded(files: any) {
        let j = 0;
        this.files = files.addedFiles;
        console.log('this.files');
        console.log(this.files);
        for (let file of this.files) {
            if (j > 4) {
                break;
            }
            let fileName: any;
            fileName = file['name'];
            if (file) {
                const reader = new FileReader();
                reader.onload = (event: any) => {
                    this.localUrl = event.target.result;
                    this.compressFile(this.localUrl, fileName);
                }
                reader.readAsDataURL(file);
            }
            j++;
        }
    }

    compressFile(image: any, fileName: string) {
        var orientation = -1;
        this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
        // console.warn('Size in bytes is now:', this.sizeOfOriginalImage);
        this.imageCompress.compressFile(image, orientation, 50, 50).then(
            result => {
                this.imgResultAfterCompress = result;
                this.localCompressedURl = result;
                this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024);
                // console.warn('Size in bytes after compression:', this.sizeOFCompressedImage);
                const imageName = fileName;
                const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
                const imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });
                this.files_temp.push(imageFile);
            });
        console.log('this.files_temp');
        console.log(this.files_temp);
    }


    dataURItoBlob(dataURI: any) {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'image/jpeg' });
        return blob;
    }


    public async uploadFile(guarantee: any) {
        debugger;
        this.successUploadCount = 0;
        this.failedUploadCount = 0;
        /* for (let file of this.files) { */
        for (let file of this.files_temp) {
            console.log(file);
            const formData = new FormData();
            if (file instanceof File) {
                formData.append('file', file, file.name);
                formData.append('item_id', guarantee.id);
                formData.append('designation', 'guarantee/' + guarantee.type);
                this.uploading = true;
                await this.mainService.upload(formData).then((res: any) => {
                    debugger;
                    this.uploadResponse = res;
                    console.log(res);
                    if (this.uploadResponse.status !== 'progress' &&
                        this.uploadResponse.status !== 'unhandeled event') {
                        this.successUploadCount++;
                        let temp = (this.successUploadCount / this.files.length) * 100;
                        this.uploadResponse.message = temp.toString();
                    }
                }, function (err) {
                });
            }

        }
        this.mainService.toast({ title: 'Success', body: (this.id) ? 'Guarantee Files successfully updated! ' : 'Ekub pictures successfully added!', type: 'dark' });

    }


    addGuarantee() {
        debugger;
        if (this.type.value == 'member') {
            if (this.userStats.total_balance <= 0) {
                this.mainService.toast({ title: 'Not enough balance', body: 'Selected Member does not have enough balance to be a guarantee!', type: 'danger' });
                return;
            } else if (this.totalGuaranteeAmount + this.winnerBalance >= 0) {
                this.mainService.toast({
                    title: 'No need', body: 'Currently added guarantee covers the winner\'s debt!', type: 'info'
                });
                return;
            }
            else {
                this.guarantees.push({
                    type: this.type.value,
                    guarantee: this.guarantee.value,
                    ref_number: this.guarantee_ref_number.value,
                    amount_guaranteed: Math.abs(this.winnerBalance),
                    guarantee_value: this.userStats.total_balance,
                    status: this.status.value,
                    balance: this.userStats.total_balance,
                    ekubs: this.userStats.ekubs.length,
                    remark: this.remark.value,
                });
                this.totalEkubs += this.userStats.ekubs.length;
                this.totalGuaranteeAmount += this.userStats.total_balance;
            }
        } else {
            //TODO check if libre/carta images are attached if () {            }
            if (this.totalGuaranteeAmount + this.winnerBalance >= 0) {
                this.mainService.toast({
                    title: 'No need', body: 'Currently added guarantee covers the winner\'s debt!', type: 'info'
                });
                return;
            } else {
                this.guarantees.push({
                    type: this.type.value,
                    guarantee: null,
                    ref_number: this.guarantee_ref_number.value,
                    amount_guaranteed: Math.abs(this.winnerBalance),
                    guarantee_value: this.guarantee_value.value,
                    status: this.status.value,
                    remark: this.remark.value,
                });
                this.totalGuaranteeAmount += this.guarantee_value.value;
            }
        }
        this.guaranteeForm.reset();

    }

    removeGuarantee(index: number) {
        debugger;
        if (this.guarantees[index].type == 'member') {
            this.totalEkubs -= this.guarantees[index].ekubs;
            this.totalGuaranteeAmount -= this.guarantees[index].balance;
        }
        this.guarantees.splice(index, 1);
    }

    saveGuarantee() {
        debugger;
        var guaranteeDTO = {
            award: this.id,
            guarantees: this.guarantees
        };
        // TODO check for add or update - current only add
        this.api.createGuarantee(guaranteeDTO, null).subscribe((res: any) => {
            debugger;
            /*  TODO add guarantee independently if (this.files.length > 0) {
               this.uploadFile(res.data.id);
             } */
            this.mainService.toast({ title: 'Success', body: (this.id) ? 'Guarantee successfully updated! ' : 'Guarantee  successfully added!', type: 'dark' });
            this.getAward(this.award.id);
        }, (err) => {
            debugger;
            err = err;
            this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
        });

    }


    changeGuaranteeStatus(id: any, status: any) {
        this.api.changeGuaranteeStatus(id, status).subscribe((res: any) => {
            debugger;
            this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
            this.getAward(this.id);
        }, (err: any) => {
            this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
        });
    }

    showImageDetail(path: string) {
        this.selectedGuaranteeImage = path;
    }

}
